<div class="content-box content-text">
    <div class="container mt-4">
        <div class="col-md-12">
            <div class="banner-superior">
                <h2 mat-dialog-title class="principal-title pt-2">{{ 'stt.modalMeet.meeting' | translate }} 2021V - {{dateMeeting}} </h2>
                <h2 class="page-title">{{ topicMeeting }}</h2>
            </div>
            <div class="text-container">
                    <mat-list>
                        <div mat-subheader >
                            <p class="subtitles">
                                <strong class="titulo">{{ 'stt.modalMeet.meetParticipant' | translate }}</strong>
                            </p>
                        </div>
                        <mat-list-item>
                            <div *ngFor="let userName of usuario">
                                <div mat-line>
                                    <mat-icon mat-list-icon>person</mat-icon>
                                    <span>{{userName.userName}}</span>
                                </div>
                            </div>

                        </mat-list-item>
                        <mat-divider></mat-divider>                        
                    </mat-list>
                   
                    <mat-list>
                        <div mat-subheader><p class="subtitles"><strong class="titulo">{{ 'stt.modalMeet.agenda' | translate }}</strong></p></div>
                        <div *ngIf="idiom != 'Español'">
                            <mat-list-item *ngFor="let agenda of agen" class="d-flex flex-row align-items-start">
                                    <div class="topic-item ">
                                        <div mat-line>
                                            <mat-icon mat-list-icon>note</mat-icon>
                                            <!-- <p style="  white-space: pre-line;"> -->
                                            <span>{{agenda.topicEs}}</span>
                                                <!-- </p> -->
                                        </div>
                                    </div>

                            </mat-list-item>
                            <mat-divider></mat-divider>
                        </div>

                        <div *ngIf="idiom == 'Español'">
                            <mat-list-item *ngFor="let agenda of agen" class="d-flex flex-row align-items-start">
                                    <div class="topic-item ">
                                        <div mat-line>
                                            <mat-icon mat-list-icon>note</mat-icon>
                                            <!-- <p style="  white-space: pre-line;"> -->
                                            <span>{{agenda.topicEs}}</span>
                                                <!-- </p> -->
                                        </div>
                                    </div>

                            </mat-list-item>
                            <mat-divider></mat-divider>
                        </div>
                    </mat-list>
            </div>
            <div mat-dialog-actions>
                <button class="button-close" mat-button (click)="closeModal()">
                    <mat-icon aria-hidden="false" aria-label="close">close</mat-icon>{{ 'stt.modalMeet.cancel' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
